import React, {forwardRef} from 'react';
import styles from './shot-map-goal-view.module.scss';
import classnames from "classnames";
import {ShotMapGoalViewGoal} from "./shot-map.goal-view.goal";
import {ShotMapGoalViewShots} from "./shot-map.goal-view.shots";

export const ShotMapGoalViewContent = forwardRef(({
                                                    containerHeight,
                                                    events,
                                                    goalFrame,
                                                    game,
                                                    onChange
                                                  }, ref) => {
  const goalContainerProps = {
    className: classnames(styles.goal_container),
    style: {height: containerHeight},
    ref
  }

  const goalProps = {
    width: goalFrame.width,
    height: goalFrame.height
  }

  const shotsProps = {
    game,
    events,
    onChange
  }

  return (
    <div {...goalContainerProps}>
      <ShotMapGoalViewGoal {...goalProps}/>
      <ShotMapGoalViewShots {...shotsProps}/>
    </div>
  )
})
